import { Button } from '@/components/UI'
import { useCampaignSlug } from '@/core/app/useCampaignSlug'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

type NotFoundProps = {
  /** 「ホームへ」ボタンを表示するか（不存在キャンペーンでは false にしてループを防ぐ） */
  withHome?: boolean
  /** 補足メッセージ（未指定時は汎用の Not Found 文言） */
  message?: string
}

/**
 * 404 ビューの共通コンポーネント。
 *
 * - `pages/404.tsx`（Next.js のルーティング 404）
 * - `CampaignNotFoundGuard`（存在しないキャンペーンアクセス時）
 * の両方から再利用する。
 *
 * 存在しないキャンペーンではテーマ色がフォールバック（グレー）になるため、
 * 配色はテーマに依存しない白背景・暗色テキストで固定する。
 */
export const NotFound = ({ withHome = true, message }: NotFoundProps) => {
  const { t } = useTranslation()
  const router = useRouter()
  const { gen } = useCampaignSlug()

  return (
    <div className="min-h-screen bg-white px-4 pt-10 pb-6">
      <h1 className="text-center text-big font-bold">404</h1>
      <p className="text-center text-sm font-bold">Not Found</p>
      <p className="mt-10 text-center text-xsss">
        {message ?? t('error.404.page_not_found', 'お探しのページは見つかりませんでした。')}
      </p>
      {withHome && (
        <div className="mt-14 flex justify-center">
          <Button
            label={t('error.back_home', 'ホームへ')}
            onClick={() => {
              router.push(gen('/'))
            }}
            className="w-9/12"
          />
        </div>
      )}
    </div>
  )
}
